import { render, staticRenderFns } from "./PercentageCircle.vue?vue&type=template&id=19990a4b&scoped=true&"
import script from "./PercentageCircle.vue?vue&type=script&lang=js&"
export * from "./PercentageCircle.vue?vue&type=script&lang=js&"
import style0 from "./PercentageCircle.vue?vue&type=style&index=0&id=19990a4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19990a4b",
  null
  
)

export default component.exports